// Beheer van de offerte-producten die "Nog in te plannen" optelt. Besluit
// 9 sep 2026: Monteren → montage, Animeren → animatie, Feedback verwerken →
// feedback; norm vier productieve uur per werkdag. Één productnaam per regel;
// een Gripp-productnummer (20004) mag ook.
import { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import { BACKEND_URL } from '../../../utils/apiConfig';
import { authFetch } from '../../../utils/authHelpers';
import { leesJson } from '../../../utils/apiFout';

const VELDEN = [
  { key: 'montage', label: 'Montage', hint: 'Bijv. Monteren, Kleurcorrigeren' },
  { key: 'animatie', label: 'Animatie', hint: 'Bijv. Animeren, Illustreren' },
  { key: 'feedback', label: 'Feedback verwerken', hint: 'Bijv. Feedback verwerken' },
];
const regels = (tekst) => tekst.split('\n').map((x) => x.trim()).filter(Boolean);

export default function InplannenProducten() {
  const [vorm, setVorm] = useState({ montage: '', animatie: '', feedback: '', normUrenPerDag: 4 });
  const [laden, setLaden] = useState(true);
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState(null);

  useEffect(() => {
    authFetch(`${BACKEND_URL}/Api/inplannen/productmap`)
      .then((r) => leesJson(r, 'Productmap laden'))
      .then(({ productmap }) => setVorm({
        montage: (productmap.montage || []).join('\n'),
        animatie: (productmap.animatie || []).join('\n'),
        feedback: (productmap.feedback || []).join('\n'),
        normUrenPerDag: productmap.normUrenPerDag ?? 4,
      }))
      .catch((e) => setMelding({ type: 'error', tekst: e.message }))
      .finally(() => setLaden(false));
  }, []);

  const opslaan = async () => {
    setBezig(true); setMelding(null);
    try {
      const body = {
        montage: regels(vorm.montage), animatie: regels(vorm.animatie), feedback: regels(vorm.feedback),
        normUrenPerDag: Number(vorm.normUrenPerDag) || 4,
      };
      const r = await authFetch(`${BACKEND_URL}/Api/inplannen/productmap`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
      });
      await leesJson(r, 'Productmap opslaan');
      setMelding({ type: 'success', tekst: 'Opgeslagen — Nog in te plannen rekent bij de volgende verversing met deze producten.' });
    } catch (e) {
      setMelding({ type: 'error', tekst: e.message });
    } finally { setBezig(false); }
  };

  if (laden) return <CircularProgress size={22} />;
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Welke offerteregels tellen mee als montage, animatie en feedback in <b>Planning → Nog in te plannen</b>.
        Eén productnaam per regel, precies zoals hij in Gripp heet (het nummer tussen haakjes mag ook).
      </Typography>
      <Stack spacing={2}>
        {VELDEN.map((v) => (
          <TextField key={v.key} label={v.label} helperText={v.hint} multiline minRows={2} maxRows={8} fullWidth
            value={vorm[v.key]} onChange={(e) => setVorm((p) => ({ ...p, [v.key]: e.target.value }))} />
        ))}
        <TextField label="Productieve uren per werkdag" type="number" inputProps={{ min: 1, max: 10, step: 0.5 }} sx={{ maxWidth: 260 }}
          helperText="Voor de ruimte tot de deadline en het signaal 'past niet'"
          value={vorm.normUrenPerDag} onChange={(e) => setVorm((p) => ({ ...p, normUrenPerDag: e.target.value }))} />
      </Stack>
      {melding && <Alert severity={melding.type} sx={{ mt: 1.5 }}>{melding.tekst}</Alert>}
      <Button variant="contained" onClick={opslaan} disabled={bezig}
        startIcon={bezig ? <CircularProgress size={14} color="inherit" /> : null}
        sx={{ mt: 1.5, textTransform: 'none', fontWeight: 700 }}>
        Opslaan
      </Button>
    </Box>
  );
}
